module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/euro-d69d23f8ec27343bfc095144e5467504.webp";